<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
      <div class="mb-3">
        <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="taskFormData.name" class="w-full"/>
        <validation-error :model-error="taskFormErrors.name"></validation-error>
      </div>
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('assigned_to')"></label>
        <v-select :options="userOptions" multiple :reduce="label => label.value" :placeholder="$t('assigned_to')" v-model="taskFormData.assigned_to" class="md:mb-0 hide-selected-item" />
        <validation-error :model-error="taskFormErrors.assigned_to"></validation-error>
      </div>
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('category')"></label>
<!--        <v-select :options="categoryOptions" :reduce="label => label.value" :placeholder="$t('category')" v-model="taskFormData.task_category_id" class="md:mb-0" />-->
        <select v-model="taskFormData.task_category_id" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('category') }}</option>
          <option v-for="(option, key) in categoryOptions" :key="'category_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="taskFormErrors.task_category_id"></validation-error>
      </div>
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('due_date')"></label>
        <date-picker v-model="taskFormData.due_date" :model="taskFormData.due_date" :placeholder="$t('due_date')"></date-picker>
        <validation-error :model-error="taskFormErrors.due_date"></validation-error>
      </div>

      <vs-divider position="center" border-style="dashed">Additional Information</vs-divider>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label" v-text="$t('start_date')"></label>
          <date-picker v-model="taskFormData.start_date" :model="taskFormData.start_date" :placeholder="$t('start_date')"></date-picker>
          <validation-error :model-error="taskFormErrors.start_date"></validation-error>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label" v-text="$t('reminder_date')"></label>
          <date-picker v-model="taskFormData.reminder_date" :model="taskFormData.reminder_date" :placeholder="$t('reminder_date')"></date-picker>
          <validation-error :model-error="taskFormErrors.reminder_date"></validation-error>
        </div>
      </div>

      <div class="mb-3">
        <label class="vs-input--label flex align-center">
          <span class="mr-2">{{ $t('progress') }}:</span>
          <vs-chip color="primary" class="float-none p-2" v-text="`${taskFormData.progress}%`"></vs-chip>
        </label>
        <div class="p-1">
          <vs-slider v-model="taskFormData.progress" />
        </div>
      </div>
    </div>

    <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('priority')"></label>
<!--        <v-select :options="priorityOptions" :reduce="label => label.value" :placeholder="$t('priority')" v-model="taskFormData.priority_id" class="md:mb-0" />-->
        <select v-model="taskFormData.priority_id" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('priority') }}</option>
          <option v-for="(option, key) in priorityOptions" :key="'priority_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="taskFormErrors.priority_id"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('progress_status')"></label>
<!--        <v-select :options="progressStatusOptions" :reduce="label => label.value" :placeholder="$t('progress_status')" v-model="taskFormData.progress_status_id" class="md:mb-0" />-->
        <select v-model="taskFormData.progress_status_id" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('progress_status') }}</option>
          <option v-for="(option, key) in progressStatusOptions" :key="'progress_status_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="taskFormErrors.progress_status_id"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('related_to')"></label>
<!--        <v-select :options="projectOptions" :reduce="label => label.value" :placeholder="$t('related_to')" v-model="taskFormData.related_to" class="md:mb-0" />-->
        <select v-model="taskFormData.related_to" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('related_to') }}</option>
          <option v-for="(option, key) in projectOptions" :key="'related_to_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="taskFormErrors.related_to"></validation-error>
      </div>

      <div class="mb-3">
        <vs-input :label="$tc('link', 2)" :placeholder="$tc('link', 2)" v-model="taskFormData.links" class="w-full"/>
        <validation-error :model-error="taskFormErrors.links"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('visibility')"></label>
<!--        <v-select :options="visibilityOptions" :reduce="label => label.value" :placeholder="$t('visibility')" v-model="taskFormData.visibility" class="md:mb-0" />-->
        <select v-model="taskFormData.visibility" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('visibility') }}</option>
          <option v-for="(option, key) in visibilityOptions" :key="'visibility_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="taskFormErrors.visibility"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('description')"></label>
        <vs-textarea class="mb-0" v-model="taskFormData.description" :placeholder="$t('description')" />
        <validation-error :model-error="taskFormErrors.description"></validation-error>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import DatePicker from '@/components/form-inputs/DatePicker'
import Task from '@/models/Task'

export default {
  name: 'Shared.Tasks.Edit',
  data () {
    return {
      taskFormData: {
        task_category_id: '',
        name: '',
        description: '',
        due_date: '',
        start_date: '',
        reminder_date: '',
        progress: 0,
        priority_id: '',
        progress_status_id: '',
        related_to: '',
        visibility: 0,
        assigned_to: [],
        links: ''
      },
      taskFormErrors: {}
    }
  },
  components: {
    DatePicker
  },
  props: {
    categoryOptions: {
      required: true,
      type: [Object, Array]
    },
    progressStatusOptions: {
      required: true,
      type: [Object, Array]
    },
    priorityOptions: {
      required: true,
      type: [Object, Array]
    },
    visibilityOptions: {
      required: true,
      type: [Object, Array]
    },
    userOptions: {
      required: true,
      type: [Object, Array]
    },
    projectOptions: {
      required: true,
      type: [Object, Array]
    }
  },
  mounted () {
    EventBus.$on('initTaskFormData', this.initTaskFormData)
    EventBus.$on('initEditTask', this.initEditTask)
    EventBus.$on('initUpdateTask', this.initUpdateTask)
  },
  methods: {
    initTaskFormData () {
      this.taskFormData = {
        task_category_id: '',
        name: '',
        description: '',
        due_date: '',
        start_date: '',
        reminder_date: '',
        progress: 0,
        priority_id: '',
        progress_status_id: '',
        related_to: '',
        visibility: 0,
        assigned_to: [],
        links: ''
      }
      this.taskFormErrors = {}
    },
    async initEditTask (data) {
      this.$vs.loading({container: '#EditTaskFormContainer'})
      try {
        const response = await Task.view({ id: data.id })
        this.taskFormData = response.data.data
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#EditTaskFormContainer > .con-vs-loading')
    },
    async initUpdateTask () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editTaskButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await Task.update(this.taskFormData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.initTaskFormData()
          this.$emit('editTaskSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.taskFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#editTaskButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #editTaskButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
